import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";

import getRelatedCoverData from "@/components/organisms/quote/quote-cover/dynamic-data-map/magnolia-data-map";
import { CoverAreaDataType } from "@/schema/quote-page/page.schema";
import { RootState } from "@/store/root-reducer";
import isCruiseImpact from "@/utils/check-cruise-impact-base-on-brand.utils";

import Cover from "../cover/cover";

type CoverWrapperProps = {
  quoteAreaData?: CoverAreaDataType;
  onlineExclusiveBannerLabel?: string;
  cardTopData?: {
    selectBtnInactiveLable?: string;
    selectBtnActiveLable?: string;
    isLoading?: boolean;
  };
  selectedCoverLevel: string;
  updateCoverType: boolean;
  onSelect?: (val: string, state: boolean, key: number) => void;
  isSticky: boolean;
};

function CoverWrapper({
  quoteAreaData,
  onlineExclusiveBannerLabel,
  cardTopData = {},
  selectedCoverLevel,
  updateCoverType,
  onSelect,
  isSticky = true,
}: Readonly<CoverWrapperProps>) {
  const blueBannerRef = useRef<HTMLDivElement | null>(null);
  const [selectedTab, setSelectedTab] = useState("");
  const [totalSlides, setTotalSlides] = useState<number>(0);
  const quoteData = useSelector((state: RootState) => state.quote);
  const { attributes } = quoteData;

  const { tripDetails } = attributes;

  const [blueBannerHeight, setBlueBannerHeight] = useState(0);

  useEffect(() => {
    if (tripDetails?.policyType) {
      setSelectedTab(tripDetails.policyType);
    }
  }, [tripDetails]);

  const getCoverLevelData = (tripType: string) => {
    const dataList = getRelatedCoverData(
      quoteAreaData,
      tripDetails?.goingOnCruise && isCruiseImpact,
      tripType
    ).filter((item) => item !== null)[0];
    if (dataList?.length && totalSlides === 0) {
      setTotalSlides(dataList?.length ?? 0);
    }
    return dataList;
  };

  const coverLevelItemData = useMemo(() => {
    return getCoverLevelData(selectedTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab]);

  return (
    <div
      className={`
    flex items-stretch sticky z-[1] transition-all duration-300 ease-in-out
    ${isSticky ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0"}
  `}
      style={{ top: `-${blueBannerHeight}px` }}
    >
      {coverLevelItemData?.map((item, index) => (
        <Cover
          key={index as unknown as string}
          keyValue={item.coverType}
          type={selectedTab}
          cardTitle={item.coverTitle}
          onlineExclusiveBannerLabel={onlineExclusiveBannerLabel}
          id={index}
          cardTopData={{
            ...cardTopData,
            isLoading: updateCoverType && selectedCoverLevel === item.coverType,
          }}
          slectState={
            tripDetails?.initialQuotePageLoading !== true &&
            tripDetails?.policyPackage === item.coverType
          }
          onSelect={(val, state, key) => onSelect && onSelect(val, state, key)}
          blueBannerRef={blueBannerRef}
          setBlueBannerHeight={setBlueBannerHeight}
        />
      ))}
    </div>
  );
}

export default CoverWrapper;
